/** A dynamic import loaded once and shared by every caller, which also reports how far it has got. */
/**
 * `load` once, on the first call, shared by every later call. A failed import stays failed.
 *
 * @canonical A dynamic import loaded once
 */
export function memoisedImport(load) {
    let pending = null;
    let state = 'loading';
    const memoised = () => (pending ??= load().then((module) => {
        state = { module };
        return module;
    }, (error) => {
        state = 'failed';
        throw error;
    }));
    return Object.assign(memoised, { state: () => state });
}
//# sourceMappingURL=memoisedImport.js.map